/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Close } from '@mui/icons-material'
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  Grid,
  Icon,
  Typography,
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { CountrySelect } from 'components/Common/CountrySelect/CountrySelect'
import React, { FC } from 'react'
import { supplierOperationsAPI } from '../../../../api/supplier/supplierOperationsAPI'
import { ServicedArea } from '../../../../api/supplier/supplierOperationsAPI.types'
import {
  useSupplierDispatch,
  useSupplierState,
} from '../../../../Pages/Supplier/SupplierContext'
import Input from '../../../FormFields/Input/Input'
import { withServicedAreas } from './Operations.hoc'
import styles from './operationsStyle'

interface Props {
  mode: 'create' | 'edit' | 'view'
}

const ServicedAreas: FC<Props> = (props) => {
  const { servicedAreas = [], supplierOperation } = useSupplierState()
  console.log('servicedAreas', servicedAreas)
  const dispatch = useSupplierDispatch()
  const { mode } = props
  const [countryCode, setCountryCode] = React.useState()
  const [area, setArea] = React.useState('')
  const [excludedArea, setExcludedArea] = React.useState(false)
  const [expanded, setExpanded] = React.useState(false)

  const { mutate } = useMutation(
    (value: { operationsId: number; servicedAreaId: number }) => {
      return supplierOperationsAPI.deleteServicedArea(
        value.operationsId,
        value.servicedAreaId,
      )
    },
  )

  const handleAddServicedArea = () => {
    if (area && area !== '') {
      const cleaned = area.trim()
      let areaCodes: Array<ServicedArea> = []
      if (cleaned.includes(',')) {
        cleaned.split(/[,]+/).map((val) => {
          val &&
            areaCodes.push({
              postCode: val,
              countryCode: countryCode,
              isExcluded: excludedArea,
            })
        })
      } else {
        areaCodes.push({
          postCode: cleaned,
          countryCode: countryCode,
          isExcluded: excludedArea,
        })
      }
      const mergedServicedAreas = [...servicedAreas, ...areaCodes]
      const uniqueServicedAreas = Array.from(
        new Set(mergedServicedAreas.map((a) => a.postCode)),
      ).map((postCode) => {
        return mergedServicedAreas.find((a) => a.postCode === postCode)
      })
      dispatch({ type: 'addServicedAreas', payload: mergedServicedAreas })
      dispatch({ type: 'setServicedAreas', payload: uniqueServicedAreas })
      setArea('')
      setExcludedArea(false)
    }
  }

  React.useEffect(() => {
    console.log(servicedAreas)
  }, [servicedAreas])

  const handleDelete = (target: ServicedArea) => {
    const updated = servicedAreas.filter(
      (sa) =>
        sa.countryCode !== target.countryCode ||
        sa.postCode !== target.postCode,
    )
    dispatch({ type: 'setServicedAreas', payload: updated })
  }
  console.log('component serviced areas', servicedAreas)
  return (
    <Grid
      container
      spacing={2}
      direction="row"
      alignItems="center"
      width={'100%'}
    >
      <Grid item xs={12}>
        <Card sx={styles.servicedAreaContainer}>
          <Grid container>
            <CardContent style={{ width: '100%', backgroundColor: 'white' }}>
              <Grid container item xs={12} alignItems="center">
                <Grid item xs={9}>
                  <Typography variant="body1">
                    This supplier has{' '}
                    {servicedAreas?.filter((sa) => !sa.isExcluded).length || 0}{' '}
                    {servicedAreas?.filter((sa) => !sa.isExcluded).length === 1
                      ? 'serviced area'
                      : 'serviced areas'}{' '}
                    and{' '}
                    {servicedAreas?.filter((sa) => sa.isExcluded).length || 0}{' '}
                    {servicedAreas?.filter((sa) => sa.isExcluded).length === 1
                      ? 'excluded area'
                      : 'excluded areas'}
                    .
                  </Typography>
                </Grid>
                <Grid item xs={3} style={{ textAlign: 'right' }}>
                  {servicedAreas.length > 0 && (
                    <Button
                      onClick={() => setExpanded(!expanded)}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      {expanded ? 'Collapse' : 'Expand'}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </CardContent>
            <Collapse
              in={expanded}
              style={{ width: '100%' }}
              timeout="auto"
              unmountOnExit
            >
              <CardContent style={{ width: '100%', backgroundColor: 'white' }}>
                <Grid
                  container
                  sx={{ marginTop: '16px', marginBottom: '16px' }}
                >
                  <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Serviced Areas{' ('}
                      {servicedAreas?.filter((sa) => !sa.isExcluded).length ||
                        0}
                      {') '}
                      <Typography variant="caption" component="span">
                        (scrollable)
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    sx={{ maxHeight: '300px', overflowY: 'auto' }}
                  >
                    {servicedAreas &&
                      servicedAreas
                        .filter((sa) => !sa.isExcluded)
                        .sort((a, b) => a.postCode.localeCompare(b.postCode))
                        .map((sa, i) => {
                          return (
                            <Grid
                              item
                              key={`${sa.postCode}_${i}_${sa.id}`}
                              xs="auto"
                              sx={{
                                ...styles.servicedChipContainer,
                              }}
                            >
                              <Chip
                                label={sa.postCode}
                                color="primary"
                                variant="outlined"
                                deleteIcon={
                                  mode === 'edit' ? (
                                    <Close fontSize="small" />
                                  ) : (
                                    <></>
                                  )
                                }
                                {...(mode === 'edit'
                                  ? { onDelete: () => handleDelete(sa) }
                                  : undefined)}
                                sx={styles.servicedChip}
                              />
                            </Grid>
                          )
                        })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  sx={{ marginTop: '16px', marginBottom: '16px' }}
                >
                  <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Excluded Areas{' ('}
                      {servicedAreas?.filter((sa) => sa.isExcluded).length || 0}
                      {') '}
                      <Typography variant="caption" component="span">
                        (scrollable)
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    sx={{ maxHeight: '300px', overflowY: 'auto' }}
                  >
                    {servicedAreas &&
                      servicedAreas
                        .filter((sa) => sa.isExcluded)
                        .sort((a, b) => a.postCode.localeCompare(b.postCode))
                        .map((sa, i) => {
                          return (
                            <Grid
                              item
                              key={`${sa.postCode}_${i}_${sa.id}`}
                              xs="auto"
                              sx={styles.servicedChipContainer}
                            >
                              <Chip
                                label={sa.postCode}
                                color="primary"
                                variant="outlined"
                                deleteIcon={mode === 'edit' ? <Close /> : <></>}
                                {...(mode === 'edit'
                                  ? { onDelete: () => handleDelete(sa) }
                                  : undefined)}
                                sx={styles.servicedChip}
                              />
                            </Grid>
                          )
                        })}
                  </Grid>
                </Grid>
              </CardContent>
            </Collapse>
          </Grid>
        </Card>
      </Grid>
      {(mode === 'edit' || mode === 'create') && (
        <Grid
          container
          style={{ marginLeft: '5px', marginTop: '5px' }}
          spacing={2}
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3} sx={{ display: 'flex', gap: '15px' }}>
            <Input
              label="New serviced area (i.e. Post / Zip code)"
              value={area}
              onChange={(e) => setArea(e.target.value.toUpperCase())}
              sx={{ ...styles.inputField }}
            />
            <CountrySelect value={countryCode} onChange={setCountryCode} />
            <FormControlLabel
              control={
                <Checkbox
                  checked={excludedArea}
                  onChange={() => setExcludedArea(!excludedArea)}
                />
              }
              label={'Exclude this area'}
              sx={{ minWidth: '200px' }}
            />
            <Button
              endIcon={<Icon sx={{ alignSelf: 'center' }}>add</Icon>}
              onClick={handleAddServicedArea}
              disabled={!countryCode || !area}
            >
              Add serviced area
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default withServicedAreas(ServicedAreas)
